/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";

export const auctionLotSlice = createSlice({
  name: "auctionlot",
  initialState: {
    auctionLot: {},
  },
  reducers: {
    setLot: (state, action) => {
      state.auctionLot = action.payload;
    },
  },
});

export const { setLot } = auctionLotSlice.actions;

export default auctionLotSlice.reducer;
